import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusIncorrectIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_39214_181",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 7.99667C0 3.58023 3.58023 0 7.99667 0C12.4131 0 15.9933 3.58023 15.9933 7.99667C15.9933 12.4131 12.4131 15.9933 7.99667 15.9933C3.58023 15.9933 0 12.4131 0 7.99667Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 7.99667C0 3.58023 3.58023 0 7.99667 0C12.4131 0 15.9933 3.58023 15.9933 7.99667C15.9933 12.4131 12.4131 15.9933 7.99667 15.9933C3.58023 15.9933 0 12.4131 0 7.99667Z",
			fill: "#C62828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 7.99667M15.9933 7.99667M15.9933 7.99667M0 7.99667M7.99667 0M15.9933 7.99667M7.99667 15.9933M0 7.99667M7.99667 15.9933V14.8856C4.19203 14.8856 1.10776 11.8013 1.10776 7.99667H0H-1.10776C-1.10776 13.0249 2.96843 17.1011 7.99667 17.1011V15.9933ZM15.9933 7.99667H14.8856C14.8856 11.8013 11.8013 14.8856 7.99667 14.8856V15.9933V17.1011C13.0249 17.1011 17.1011 13.0249 17.1011 7.99667H15.9933ZM7.99667 0V1.10776C11.8013 1.10776 14.8856 4.19203 14.8856 7.99667H15.9933H17.1011C17.1011 2.96843 13.0249 -1.10776 7.99667 -1.10776V0ZM7.99667 0V-1.10776C2.96843 -1.10776 -1.10776 2.96843 -1.10776 7.99667H0H1.10776C1.10776 4.19203 4.19203 1.10776 7.99667 1.10776V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9966 4.99664L4.99664 10.9966",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9966 10.9966L4.99664 4.99664",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuestionStatusIncorrectIcon;
